import Attendee from ".";

export const attendeeRoute = () => [
  {
    path: "/:lang/user/myEvent/attendees/:eventId",
    title: "My Event",
    layout: "frontUserInner",
    routeType: "organization",
    component: Attendee,
  },
];
